import React, { useContext, useEffect, useRef, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import SectionWithTag from '../../../../components/SectionWithTag'
import Carousel from './components/Carousel'
import { Waypoint } from 'react-waypoint'
import PaddingContext from '../../../../utils/PaddingContext'

const id = 'page.applications.reimagined'

const data = [
    'Glycosyltransferases',
    'DNA-dependent RNA polymerases',
    'RNA-dependent DNA polymerases',
    'Flavin reductases',
    'Endonucleases',
    'Phosphatases',
    'Glycosidases',
    'Dehydrogenases',
    'Carbon-carbon lyases',
    'Carbon-oxygen lyases',
    'Pore-forming proteins',
    'Protein Binders',
    'Ketoreductases',
    'Epimerases',
    'Amidases',
    'Proteolytic enzymes',
    'Esterases',
]

const Reimagined = () => {
    const { padding } = useContext(PaddingContext)

    const [isVisible, setIsVisible] = useState(false)
    const [boundaries, setBoundaries] = useState({ left: 0, right: 0 })
    const titleRef = useRef<HTMLDivElement>(null)
    const scrollRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const calculateRefs = () => {
            requestAnimationFrame(() => {
                if (titleRef.current && scrollRef.current && isVisible) {
                    const left = titleRef.current.getBoundingClientRect().left
                    const right = left + titleRef.current?.offsetWidth - scrollRef.current.offsetWidth
                    setBoundaries({ left, right })
                }
            })
        }
        calculateRefs()

        window.addEventListener('resize', calculateRefs)
        return () => window.removeEventListener('resize', calculateRefs)
    }, [titleRef, scrollRef, isVisible])

    return (
        <div className='bg-white relative'>
            <div className='py-12 md:py-30 relative border-b border-black/10'>
                <SectionWithTag
                    tag={{ id: `${id}.tag` }}
                    className='3xl:max-w-screen-2xl mx-auto'
                    padding={padding}
                >
                    <div
                        className='flex md:flex-row flex-col items-center justify-between gap-y-8 md:gap-y-0 justify-between py-9 md:pt-0 md:pb-20'
                        ref={titleRef}
                    >
                        <div className='md:max-w-[670px]'>
                            <FormattedMessage id={id} tagName='h2' />
                        </div>

                        {/* <div className='md:max-w-[300px]'>
                            <FormattedMessage id={`${id}.description`} tagName='p' />
                        </div> */}
                    </div>
                </SectionWithTag>
                <Waypoint onEnter={() => setIsVisible(true)}>
                    <div className='flex flex-col cursor-grab' ref={scrollRef}>
                        <Carousel
                            items={data}
                            boundaries={boundaries}
                            isVisible={isVisible}
                            scrollRef={scrollRef}
                            id={'carousel-1'}
                        />
                        <Carousel
                            reverse
                            items={[...data].reverse()}
                            boundaries={boundaries}
                            isVisible={isVisible}
                            scrollRef={scrollRef}
                            id={'carousel-2'}
                        />
                    </div>
                </Waypoint>
            </div>
        </div>
    )
}

export default Reimagined
